import YourJourneyCatchUpDto from "../types/dtos/catch-ups/YourJourneyCatchUpDto";
import AdvTaskListingDto from "../types/dtos/dashboards/manager/listings/adv-tasks/AdvTaskListingDto";
import JourneyListingDto from "../types/dtos/dashboards/manager/listings/journey/JourneyListingDto";

export const listingHelper = {
  getJourneyStatusText: (
    item: JourneyListingDto | YourJourneyCatchUpDto
  ): string => {
    if (item.isForceClosed) {
      return "Closed";
    }

    switch (item.overallStatus) {
      case "UPCOMING":
        return "Upcoming";
      case "NOT-STARTED":
        return "Not Started";
      case "IN-PROGRESS":
        return "In Progress";
      case "COMPLETED":
        return "Completed";
      default:
        return "Unknown";
    }
  },
  getJourneyStatusColor: (
    item: JourneyListingDto | YourJourneyCatchUpDto
  ): string => {
    if (item.isForceClosed) {
      return "bg-green-100 text-green-700";
    }

    switch (item.overallStatus) {
      case "UPCOMING":
        return "bg-blue-100 text-blue-700";
      case "NOT-STARTED":
        return "bg-red-100 text-red-700";
      case "IN-PROGRESS":
        return "bg-yellow-100 text-yellow-700";
      case "COMPLETED":
        return "bg-green-100 text-green-700";
      default:
        return "bg-gray-100 text-gray-600";
    }
  },
  getTaskStatusText: (item: AdvTaskListingDto): string => {
    switch (item.overallStatus) {
      case "ACTIVE":
        return "Active";
      case "OVERDUE":
        return "Overdue";
      case "COMPLETED":
        return "Completed";
      case "HISTORIC":
        return "Historic";
      case "CANCELLED":
        return "Cancelled";
      default:
        return "Unknown";
    }
  },
  getTaskStatusColor: (item: AdvTaskListingDto): string => {
    switch (item.overallStatus) {
      case "ACTIVE":
        return "bg-yellow-100 text-yellow-700";
      case "OVERDUE":
        return "bg-orange-100 text-orange-700";
      case "COMPLETED":
        return "bg-green-100 text-green-700";
      case "CANCELLED":
        return "bg-red-100 text-red-700";
      case "HISTORIC":
        return "bg-gray-100 text-gray-700";
      default:
        return "bg-gray-100 text-gray-600";
    }
  },
  getOwnerBorderClass: (task: AdvTaskListingDto) => {
    // Use the highlighted to manager if applicable
    if (task.highlightToOwner) {
      return "!border-l-2 border-l-primary";
    }

    // No border if neither condition is true
    return "";
  },
  getManagerBorderClass: (task: AdvTaskListingDto) => {
    // Use the highlighted to manager if applicable
    if (task.highlightToManager) {
      return "!border-l-2 border-l-primary";
    }

    // No border if neither condition is true
    return "";
  },
  getDualPrepStatusIconColor: (
    isCompleted: boolean,
    isAvailable: boolean = true,
    hasStarted: boolean = true
  ): string => {
    if (isCompleted) {
      return "text-green-600";
    }
    if (!isAvailable) {
      return "text-gray-400";
    }
    if (!hasStarted) {
      return "text-red-600";
    }
    return "text-yellow-600";
  },
  getDualPrepStatusTextColor: (
    isCompleted: boolean,
    isAvailable: boolean = true,
    hasStarted: boolean = true
  ): string => {
    if (isCompleted) {
      return "text-green-700";
    }
    if (!isAvailable) {
      return "text-gray-500";
    }
    if (!hasStarted) {
      return "text-red-700";
    }
    return "text-yellow-700";
  },
};

export default listingHelper;
